import classnames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';

export interface BlotterPanelDocumentListItemProps {
  children: ReactNode;
  className?: string;
  e2e?: string;
  icon?: string;
  nameKey?: IntlKey;
  name?: string;
}

export const BlotterPanelDocumentListItemLegacy: FC<BlotterPanelDocumentListItemProps> = ({
  children,
  className,
  e2e = 'blotter-panel-document',
  icon = 'insert_drive_file',
  name,
  nameKey,
}) => (
  <div className={classnames('list-group-item border d-flex py-1 px-2', className)} data-e2e={e2e}>
    <div className="d-flex align-items-center me-auto text-secondary">
      <i className="icon icon-sm me-2">{icon}</i>
      <FormattedMessage id={nameKey} defaultMessage={name} />
    </div>
    {children}
  </div>
);

BlotterPanelDocumentListItemLegacy.displayName = 'BlotterPanelDocumentListItemLegacy';
